export default __webpack_public_path__ + "static/media/week-0-img.30a39a66.png";